export default class Transports {
  constructor(transports) {
    this.list = transports;
  }

  getList(){
    return this.list;
  }

  getByName(name) {
    return this.list[name];
  }
}